import React from 'react';
import { HistoryRouter } from 'redux-first-history/rr6';
import { Route, Routes, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { ROUTES } from './containers/App/routes';
import { updateLastVisitedRoute } from './helpers/utility';
import settings from './settings';
import App from './containers/App/App';
import SignIn from './containers/signIn/signIn';
import { history, RootState } from './redux/store';
import ScrollToTop from './scrollToTop';

const root = '/';
export const signInRoute = 'signin';
const createPasswordRoute = 'passwords/new';
const resetPasswordRoute = 'passwords/forgot';
const ignoredPaths = [signInRoute, createPasswordRoute, resetPasswordRoute];

type IRestrictedRouteProps = {
  isLoggedIn: boolean;
  isUnifiedLoginEnabled: boolean | undefined;
  children: any;
};

const RestrictedRoute = ({ children, isLoggedIn, isUnifiedLoginEnabled }: IRestrictedRouteProps) => {
  const location = useLocation();
  const { pathname, search } = location;

  if (ignoredPaths.includes(pathname)) {
    return null;
  }

  if (isLoggedIn) {
    if (![root, `/${ROUTES.FORBIDDEN}`].includes(pathname)) {
      updateLastVisitedRoute(`${pathname}${search}`);
    } else {
      updateLastVisitedRoute(null);
    }
  }

  const RedirectToSignInRoute = () => {
    if (isUnifiedLoginEnabled && !isLoggedIn) {
      window.location.href = settings.loginUrl || '';

      return null;
    }

    // Force page reload (just to get fresh chunks after deploy)
    if (![root, signInRoute].includes(pathname)) {
      window.location.href = `/${signInRoute}`;
    }

    return null;
  };

  return isLoggedIn ? children : <RedirectToSignInRoute />;
};

type AppRoutesProps = {
  isLoggedIn: boolean;
  isUnifiedLoginEnabled: boolean | undefined;
  isLoading: boolean;
};

const AppRoutes = ({ isLoggedIn, isUnifiedLoginEnabled, isLoading }: AppRoutesProps) => {
  if (isLoading) {
    return null;
  }

  return (
    <HistoryRouter history={history}>
      <ScrollToTop />
      <Routes>
        <Route path={root} element={<SignIn />} />
        <Route path={signInRoute} element={<SignIn />} />
        <Route path={createPasswordRoute} element={<SignIn />} />
        <Route path={resetPasswordRoute} element={<SignIn />} />
        <Route
          path="*"
          element={
            <RestrictedRoute isLoggedIn={isLoggedIn} isUnifiedLoginEnabled={isUnifiedLoginEnabled}>
              <App />
            </RestrictedRoute>
          }
        />
      </Routes>
    </HistoryRouter>
  );
};

export default connect((state: RootState) => ({
  isLoggedIn: state.Auth.isLoggedIn,
  isUnifiedLoginEnabled: state.FeatureFlags.flags?.unified_login_enabled,
  isLoading: state.AppBootstrap.isLoading,
}))(AppRoutes);
